import { ADDNEWPRODUCT, DECREMENT, INCREMENT } from "./actionTypes";

const initialState = {
  totalItem: 0,
  totalPrice: 0,
  availableItem: {
    asusVivo: 20,
    dell: 35,
    canon: 72,
  },
  cartItem: {
    asusVivo: 0,
    dell: 0,
    canon: 0,
  },
};
const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDNEWPRODUCT: {
      if (action.id === 1) {
        return {
          ...state,
          availableItem: {
            ...state.availableItem,
            asusVivo: state.availableItem.asusVivo - 1,
          },
          cartItem: {
            ...state.cartItem,
            asusVivo: state.cartItem.asusVivo + 1,
          },
          totalItem: state.totalItem + 1,
          totalPrice: state.totalPrice + action.payload,
        };
      }
      if (action.id === 2) {
        return {
          ...state,
          availableItem: {
            ...state.availableItem,
            dell: state.availableItem.dell - 1,
          },
          cartItem: {
            ...state.cartItem,
            dell: state.cartItem.dell + 1,
          },
          totalItem: state.totalItem + 1,
          totalPrice: state.totalPrice + action.payload,
        };
      }
      if (action.id === 3) {
        return {
          ...state,
          availableItem: {
            ...state.availableItem,
            canon: state.availableItem.canon - 1,
          },
          cartItem: {
            ...state.cartItem,
            canon: state.cartItem.canon + 1,
          },
          totalItem: state.totalItem + 1,
          totalPrice: state.totalPrice + action.payload,
        };
      }
      break;
    }
    case INCREMENT: {
      if (action.id === 1) {
        return {
          ...state,
          availableItem: {
            ...state.availableItem,
            asusVivo: state.availableItem.asusVivo - 1,
          },
          cartItem: {
            ...state.cartItem,
            asusVivo: state.cartItem.asusVivo + 1,
          },
          totalItem: state.totalItem + 1,
          totalPrice: state.totalPrice + action.payload,
        };
      }
      if (action.id === 2) {
        return {
          ...state,
          availableItem: {
            ...state.availableItem,
            dell: state.availableItem.dell - 1,
          },
          cartItem: {
            ...state.cartItem,
            dell: state.cartItem.dell + 1,
          },
          totalItem: state.totalItem + 1,
          totalPrice: state.totalPrice + action.payload,
        };
      }
      if (action.id === 3) {
        return {
          ...state,
          availableItem: {
            ...state.availableItem,
            canon: state.availableItem.canon - 1,
          },
          cartItem: {
            ...state.cartItem,
            canon: state.cartItem.canon + 1,
          },
          totalItem: state.totalItem + 1,
          totalPrice: state.totalPrice + action.payload,
        };
      }
      break;
    }
    case DECREMENT: {
      if (action.id === 1) {
        return {
          ...state,
          availableItem: {
            ...state.availableItem,
            asusVivo: state.availableItem.asusVivo + 1,
          },
          cartItem: {
            ...state.cartItem,
            asusVivo: state.cartItem.asusVivo - 1,
          },
          totalItem: state.totalItem - 1,
          totalPrice: state.totalPrice - action.payload,
        };
      }
      if (action.id === 2) {
        return {
          ...state,
          availableItem: {
            ...state.availableItem,
            dell: state.availableItem.dell + 1,
          },
          cartItem: {
            ...state.cartItem,
            dell: state.cartItem.dell - 1,
          },
          totalItem: state.totalItem - 1,
          totalPrice: state.totalPrice - action.payload,
        };
      }
      if (action.id === 3) {
        return {
          ...state,
          availableItem: {
            ...state.availableItem,
            canon: state.availableItem.canon + 1,
          },
          cartItem: {
            ...state.cartItem,
            canon: state.cartItem.canon - 1,
          },
          totalItem: state.totalItem - 1,
          totalPrice: state.totalPrice - action.payload,
        };
      }
      break;
    }
    default:
      return state;
  }
};

export default cartReducer;
